import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import Modal from 'react-bootstrap/Modal';
import api from './api/axiosInstance';
import base_url from './api/Config';
import TopBar from './component/TopBar';

const Employmentdetails = () => {
  const [companyName, setCompanyName] = useState('');
  const [designation, setDesignation] = useState('');
  const [professionalEmail, setProfessionalEmail] = useState('');
  const [salary, setSalary] = useState('');
  const [salaryDate, setSalaryDate] = useState('');
  const [employmentType, setEmploymentType] = useState('');
  const [ownership, setOwnership] = useState('');
  const [gst, setGst] = useState('');
  const [ownerName, setOwnerName] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [errorModal, setErrorModal] = useState(false);

  const navigate = useNavigate();
  const location = useLocation();
  const applicationId = new URLSearchParams(location.search).get('applicationId');
  const customerId    = new URLSearchParams(location.search).get('customerId');

  const handleSubmit = async () => {
    if (!companyName || !designation || !professionalEmail || !salary || !salaryDate || !employmentType || !ownership || !ownerName) {
      setErrorModal(true);
      return;
    }
    setIsLoading(true);
    try {
      await api.post(
        `${base_url}/api/professional/updateProfessional?customerId=${customerId}`,
        { companyName, designation, professionalEmail, salary, salaryDate: parseInt(salaryDate), employmentType: parseInt(employmentType), ownership: parseInt(ownership), gst, ownerName },
        { headers: { 'Content-Type': 'application/json' } }
      );
      navigate(`/Nominee?applicationId=${applicationId}&customerId=${customerId}`);
    } catch {
      setErrorModal(true);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="app-page">
      <TopBar title="Employment Details" backPath={`/BankDetail?applicationId=${applicationId}&customerId=${customerId}`} />
      {isLoading && <div className="loader-overlay"><div className="spinner-border text-light" /></div>}

      <div className="app-content">
        <div className="app-card">
          <p className="section-title">Professional Information</p>

          <div className="field-group">
            <label className="field-label">Company Name <span className="field-star">*</span></label>
            <input className="field-input" value={companyName} onChange={e => setCompanyName(e.target.value)} />
          </div>

          <div className="field-group">
            <label className="field-label">Designation <span className="field-star">*</span></label>
            <input className="field-input" value={designation} onChange={e => setDesignation(e.target.value)} />
          </div>

          <div className="field-group">
            <label className="field-label">Professional Email <span className="field-star">*</span></label>
            <input className="field-input" type="email" value={professionalEmail} onChange={e => setProfessionalEmail(e.target.value)} />
          </div>

          <div className="field-group">
            <label className="field-label">Monthly Salary <span className="field-star">*</span></label>
            <input className="field-input" type="number" value={salary} onChange={e => setSalary(e.target.value)} />
          </div>

          <div className="field-group">
            <label className="field-label">Salary Date (1–31) <span className="field-star">*</span></label>
            <input className="field-input" type="number" min="1" max="31" value={salaryDate} onChange={e => setSalaryDate(e.target.value)} />
          </div>

          <div className="field-group">
            <label className="field-label">Employment Type <span className="field-star">*</span></label>
            <select className="field-select" value={employmentType} onChange={e => setEmploymentType(e.target.value)}>
              <option value="" hidden>Select Type</option>
              <option value="1">Salaried</option>
              <option value="2">Business / Self-Employed</option>
              <option value="3">Unemployed</option>
            </select>
          </div>

          <div className="field-group">
            <label className="field-label">Ownership Type <span className="field-star">*</span></label>
            <select className="field-select" value={ownership} onChange={e => setOwnership(e.target.value)}>
              <option value="" hidden>Select Type</option>
              <option value="1">Permanent</option>
              <option value="2">Present</option>
              <option value="3">Other</option>
            </select>
          </div>

          <div className="field-group">
            <label className="field-label">GST Number</label>
            <input className="field-input" value={gst} onChange={e => setGst(e.target.value)} />
          </div>

          <div className="field-group">
            <label className="field-label">Owner Name <span className="field-star">*</span></label>
            <input className="field-input" value={ownerName} onChange={e => setOwnerName(e.target.value)} />
          </div>
        </div>

        <button className="btn-primary-app" onClick={handleSubmit} disabled={isLoading}>
          {isLoading ? 'Saving...' : 'Proceed'}
        </button>
      </div>

      <Modal show={errorModal} onHide={() => setErrorModal(false)} centered>
        <Modal.Body className="text-center p-4">
          <strong>Please fill in all required fields.</strong>
        </Modal.Body>
        <Modal.Footer>
          <button className="btn btn-secondary" onClick={() => setErrorModal(false)}>OK</button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default Employmentdetails;
